angular.module 'app'
.controller 'AddContentSelectCtrl', ($scope, $uibModalInstance, $state, config, growl, dialogs) ->

  # end save
  $scope.toGo = (flag) ->
    $uibModalInstance.close flag
